var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBubble = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 64,
    viewBox: "0 0 54 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.805 0.0650024H11.205C9.77749 0.0650024 8.36401 0.346165 7.0452 0.892433C5.72639 1.4387 4.52808 2.23938 3.51871 3.24876C2.50933 4.25813 1.70865 5.45642 1.16238 6.77523C0.616115 8.09404 0.334961 9.50754 0.334961 10.935V41.635C0.334961 43.0625 0.616115 44.476 1.16238 45.7948C1.70865 47.1136 2.50933 48.3119 3.51871 49.3213C4.52808 50.3306 5.72639 51.1313 7.0452 51.6776C8.36401 52.2238 9.77749 52.505 11.205 52.505H23.795L27.135 63.935L31.135 52.465H42.835C45.704 52.4545 48.4526 51.3101 50.4813 49.2813C52.51 47.2526 53.6544 44.5041 53.6649 41.635V10.935C53.6663 9.50801 53.3863 8.09474 52.8412 6.77599C52.296 5.45724 51.4962 4.25887 50.4877 3.24937C49.4791 2.23986 48.2815 1.43902 46.9632 0.892632C45.645 0.34624 44.232 0.0650018 42.805 0.0650024Z",
    fill: "#26AD85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.039 37.6601L14.749 28.2601L17.869 25.1801L23.299 30.6701L34.569 13.0101L38.259 15.3601L24.039 37.6601Z",
    fill: "#E6EEF9"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBubble, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bubble.ad1d5eb6.svg";
export { ForwardRef as ReactComponent };